<template>
  <div class="page" id="create-project-step-2a">
    <!-- <div class="decorative-texture top-fade">
      <img src="@/assets/img/texture.png" />
    </div>-->
    <div class="container">
      <div class="page-navigation">
        <div class="row align-items-center">
          <div class="col relative">
            <button class="button back-button back-absolute tooltip tooltip-bottom" data-tooltip="Regresar"
              @click="() => { back() }">
              <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                <path id="Color_Overlay" data-name="Color Overlay"
                  d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                  transform="translate(-23 -48.001)" />
              </svg>
            </button>

            <div class="text-center">
              <h1 class="page-title text-center">Fuentes de información</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section>
      <div class="container">
        <!-- <h1 class="section-title">Pasos</h1> -->
        <div class="steps">
          <div class="step active">
            <span>01</span>
          </div>
          <div class="step">
            <span>02</span>
          </div>
          <div class="step">
            <span>03</span>
          </div>
        </div>
        <button class="button fluid next-button" @click="() => { next() }">Siguiente</button><br>
        <component v-bind:is="nameComponent" :media="mediaName" :network="mediaName" :key="index"></component>


      </div>
    </section>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import tmedia from "@/components/busquedaAvanzada/tmedia.vue";
import smedia from "@/components/busquedaAvanzada/smedia.vue";
export default {
  name: "step2",
  components: {
    tmedia,
    smedia
  },
  data: () => ({
    index: 0,
    nProyecto: "",
    nameComponent: "",
    mediaName: ""
  }),
  methods: {
    async next() {
      console.log("next");
      this.index = this.index + 1;
      let name = this.getComponentName(this.index);
      console.log("NameComponent: " + name);
      if (name == -1) {
        //enviar mensaje de no seleccion de medios
        this.$router.push({ path: "/busqueda/nueva/step2" });
      } else {
        this.setComponent(name);
      }
    },

    getComponentName(index) {
      if (index + 1 > this.$store.state.projectConfig.fiSelect.length) {
        return -1;
      } else {
        return this.$store.state.projectConfig.fiSelect[index];
      }
    },
    setComponent(name) {
      var that = this;
      switch (name) {
        case "tv":
          that.mediaName = "T";
          that.nameComponent = "tmedia";
          break;

        case "radio":
          that.mediaName = "R";
          that.nameComponent = "tmedia";
          break;

        case "noticieros":
          that.mediaName = "PD";
          that.nameComponent = "tmedia";
          break;

        case "twitter":
          that.mediaName = "twitter";
          that.nameComponent = "smedia";
          break;

        case "youtube":
          that.mediaName = "youtube";
          that.nameComponent = "smedia";
          break;

        case "instagram":
          that.mediaName = "instagram";
          that.nameComponent = "smedia";
          break;

        case "facebook":
          that.mediaName = "facebook";
          that.nameComponent = "smedia";
          break;
        case "tiktok":
          that.mediaName = "tiktok";
          that.nameComponent = "smedia";
          break;

        default:
          break;
      }
    },
    back() {
      this.$router.push({ path: "/busqueda/nueva/step1" });
    }
  },
  beforeMount() {
    console.log("BeforeStep2a",this.index);

    let name = this.getComponentName(this.index);
    console.log("NameComponent: " + name);
    if (name == -1) {
      //enviar mensaje de no seleccion de medios
      this.$router.push({ path: "/busqueda/nueva/step1" });
    } else {
      this.setComponent(name);
    }
  }
};
</script>

<style lang="scss">
.fil1 {
  fill: #fefefe;
  fill-rule: nonzero;
}

.fil0 {
  fill: #00b99e;
  fill-rule: nonzero;
}
</style>
